<section>
  <form [formGroup]="lectureForm">
    <div id="header" class="flex-wrap">
      <div class="flex flex-wrap">
        <mat-form-field>
          <mat-label>Date de début</mat-label>
          <input matInput formControlName="date-min" [matDatepicker]="picker1" placeholder="Format : jj/mm/aaaa">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1 startView="month" panelClass="custom-calendar"></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Date de fin</mat-label>
          <input matInput formControlName="date-max" [matDatepicker]="picker2" placeholder="Format : jj/mm/aaaa">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2 startView="month" panelClass="custom-calendar"></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Etape</mat-label>
          <mat-select formControlName="type" placeholder="Sélectionner l'étape">
            <mat-option *ngFor="let etape of lectureEtapes" [value]="etape.code">{{etape.libelle}}</mat-option>
            <mat-option value="0">Toutes</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="large">
          <mat-label>Comptes</mat-label>
          <mat-select formControlName="comptes" placeholder="Sélectionner le type de compte">
            <mat-option value="c">Votre compte sélectionné</mat-option>
            <mat-option value="cs">Compte et sous-comptes</mat-option>
            <mat-option value="vcs">Vos comptes et sous-comptes</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Utilisateur</mat-label>
          <input matInput formControlName="porteur" placeholder="Saisir un utilisateur">
        </mat-form-field>
      </div>
      <button mat-raised-button color="primary" [disabled]="dataSource.data.length == 0 || loading"
        (click)="exportHistorique()" class="button-spinner{{loading?'-loading':''}}" id="button">
        <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>Export (XLSX)
      </button>
    </div>
  </form>
  <article>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container *ngFor="let column of columns">
        <ng-container matColumnDef="{{column.id}}">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.libelle }}</th>
          <td mat-cell [ngClass]="element[column.id] | typeof" *matCellDef="let element"
            [attr.data-label]=column.libelle>{{ element[column.id] }}</td>
        </ng-container>
      </ng-container>
      <ng-container matColumnDef="voirPlus">
        <th mat-header-cell *matHeaderCellDef width="80px">Voir ID Vts</th>
        <td mat-cell *matCellDef="let row" data-label="Voir ID Vts">
          <div (mouseenter)="row['show'] = true" (mouseleave)="row['show'] = false" style="position: relative;">
            <mat-icon>visibility</mat-icon>
            <div *ngIf="row['show']" id="fenetre">
              <table mat-table [dataSource]="cabList(row)">
                <ng-container matColumnDef="CAB">
                  <td mat-cell *matCellDef="let element">{{element}}</td>
                </ng-container>
                <tr mat-row *matRowDef="let row; columns: ['CAB'];"></tr>
              </table>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </article>
  <article class="no-content" *ngIf="dataSource.data.length == 0 && load.closed">
    <p>Aucun résultat</p>
  </article>
  <div [hidden]="dataSource.data.length == 0">
    <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
  </div>
</section>